import { Routes } from '@angular/router';
import { LoggedInGuard } from '@ff/core';
import { IsAdminGuard } from '../_guards/isAdminGuard';
import { IsAuthenticatedGuard } from '../_guards/isauthenticated.guard';
export const routes: Routes = [

  {
    path: 'administration',
    loadChildren: () => import('../administration/administration.module').then(m => m.AdministrationModule),
    canActivate: [IsAuthenticatedGuard, IsAdminGuard]
  },
  {
    path: 'workspace',
    loadChildren: () => import('../workspace/workspace.module').then(m => m.WorkspaceModule),
    canActivate: [IsAuthenticatedGuard]
  },
  {
    path: 'indexes',
    loadChildren: () => import('../indexes/indexes.module').then(m => m.IndexesModule),
    canActivate: [IsAuthenticatedGuard]
  },
  {
    path: 'price-list',
    loadChildren: () => import('../price-list/price-list.module').then(m => m.PriceListModule),
    canActivate: [IsAuthenticatedGuard]
  },
  // otherwise redirect to home
  {
    path: '**', redirectTo: '/price-list'
  }
];
